/**
 * Comparator view switcher
 */

export class ComparatorViewSwitch {
    constructor() {
        this.list = document.querySelector("[data-comparator-list]");
        this.table = document.querySelector("[data-comparator-scroller]");
        this.toggle = document.querySelector("[data-view-toggle]");

        if (!this.list || !this.table || !this.toggle) {
            return;
        }

        this.listButton = this.toggle.querySelector("[data-button-list]");
        this.tableButton = this.toggle.querySelector("[data-button-table]");

        if (!this.listButton || !this.tableButton) {
            return;
        }

        this.listButton.addEventListener("click", () =>
            this.switchToListView()
        );

        this.switchToListView = () => {
            this.listButton.classList.replace(
                "toggle-button-inactive",
                "toggle-button-active"
            );
            this.tableButton.classList.replace(
                "toggle-button-active",
                "toggle-button-inactive"
            );
            this.updateHistory("list");
            this.table.classList.add("hidden");
            this.list.classList.remove("hidden");
        };

        this.tableButton.addEventListener("click", () =>
            this.switchToTableView()
        );

        this.switchToTableView = () => {
            this.tableButton.classList.replace(
                "toggle-button-inactive",
                "toggle-button-active"
            );
            this.listButton.classList.replace(
                "toggle-button-active",
                "toggle-button-inactive"
            );
            this.updateHistory("comparator");
            this.list.classList.add("hidden");
            this.table.classList.remove("hidden");
        };

        this.updateHistory = (view) => {
            const url = new URL(window.location);
            url.searchParams.set("view", view);
            window.history.pushState({}, "", url);
        };

        const url = new URL(window.location);
        const view = url.searchParams.get("view");
        if (!view) {
            this.updateHistory("comparator");
        } else {
            if (view === "list") {
                this.switchToListView();
            }
        }
    }
}
